import { create } from "zustand";

interface UnseenState {
  unseenIncompleteCount: number;
  unseenSharedWithMeCount: number;
  setUnseenSharedWithMeCount: (count: number) => void;
  setUnseenIncompleteCount: (count: number) => void;
}
const DEFAULT_STATE = {
  unseenIncompleteCount: 0,
  unseenSharedWithMeCount: 0,
};

const useUnseenStore = create<UnseenState>((set) => ({
  ...DEFAULT_STATE,
  setUnseenSharedWithMeCount: (count) =>
    set({ unseenSharedWithMeCount: count }),
  setUnseenIncompleteCount: (count) => set({ unseenIncompleteCount: count }),
}));

export default useUnseenStore;
